import React, { useMemo } from 'react';
import { Flex, Button, IconName } from '@televet/kibble-ui';

interface IMergeProfilesStepperStepProps {
  index: number;
  completed: boolean;
  selected: boolean;
}

const MergeProfilesStepperStep = ({ index, completed, selected }: IMergeProfilesStepperStepProps): JSX.Element => {
  const iconName: IconName | undefined = useMemo(() => {
    if (completed) {
      return 'checkmark';
    } else if (selected) {
      return 'paw';
    }
  }, [completed, selected]);

  const buttonColor: string = useMemo(() => {
    if (completed) {
      return 'background.successContrast';
    } else if (selected) {
      return 'background.primary';
    } else {
      return 'background.moreSubtleContrast';
    }
  }, [completed, selected]);

  const backgroundColor: string = useMemo(() => {
    if (completed) {
      return 'background.successContrast';
    } else if (selected) {
      return 'transparent';
    } else {
      return 'background.moreSubtleContrast';
    }
  }, [completed, selected]);

  return (
    <Flex direction="column">
      <Flex
        m={2}
        alignItems="center"
        justifyContent="center"
        h="40px"
        w="40px"
        borderRadius="20px"
        border="1px"
        borderColor={buttonColor}
        background={backgroundColor}
      >
        <Button
          size="sm"
          borderRadius="16px"
          iconName={iconName}
          backgroundColor={buttonColor}
          _hover={{
            backgroundColor: buttonColor,
          }}
          _focus={{
            backgroundColor: buttonColor,
          }}
          _active={{
            backgroundColor: buttonColor,
          }}
          cursor="default"
        >
          {!completed && !selected ? `${index}` : ''}
        </Button>
      </Flex>
    </Flex>
  );
};

export default MergeProfilesStepperStep;
